module.exports = "<div class=\"op-modal-container\">\n\n  <div class=\"op-modal-title -simple\">\n    {{$ctrl.resolve.title}}\n  </div>\n\n  <div class=\"op-modal-dialog\">\n    <span>\n      {{$ctrl.resolve.message}}\n    </span>\n  </div>\n\n  <div class=\"op-modal-buttons -centered\">\n    <button ng-click=\"$ctrl.close()\" class=\"btn-gray\"><span>{{$ctrl.resolve.cancelCopy}}</span></button>\n    <button ng-click=\"$ctrl.close({$value: true})\" class=\"btn-red\"><span>{{$ctrl.resolve.okCopy}}</span></button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/modalconfirm.html
// module id = 43
// module chunks = 0